document.addEventListener('DOMContentLoaded', () => {

    const modal = document.querySelector('.morkes-search-modal');

    if (!modal) return;

    const close = modal.querySelector('.morkes-search-close');
    const overlay = modal.querySelector('.morkes-search-overlay');

    document.querySelectorAll('.morkes-search-trigger').forEach(trigger => {

        trigger.addEventListener('click', () => {
            modal.classList.add('open');
        });

    });

    function closeModal() {
        modal.classList.remove('open');
    }

    close?.addEventListener('click', closeModal);
    overlay?.addEventListener('click', closeModal);

    document.addEventListener('keydown', e => {
        if (e.key === 'Escape') {
            closeModal();
        }
    });

});

document.addEventListener('DOMContentLoaded', () => {
    const modal = document.getElementById('morkes-quick-shop');

    if (!modal) return;

    const closeButtons = modal.querySelectorAll('[data-morkes-close]');





    document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-morkes-quick-shop]');

        if (!trigger) return;

        event.preventDefault();

        openModal(trigger.dataset.productUrl);
    });

    closeButtons.forEach(button => {
        button.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !modal.hidden) {
            closeModal();
        }
    });
});

async function openModal(productUrl) {

    const modal = document.getElementById('morkes-quick-shop');
    const content = document.getElementById('morkes-quick-shop-content');

    content.innerHTML = '<p>Loading...</p>';

    modal.hidden = false;

    document.body.style.overflow = 'hidden';


    try {

        const response = await fetch(productUrl + '?view=morkes-quick-shop');

        const html = await response.text();

        content.innerHTML = html;

        initializeProductForm(content);

        initializeQuantityControls(

            content.querySelector('.morkes-product-form')
        );

    } catch (error) {

        content.innerHTML = '<p>Unable to load product.</p>';

        console.error(error);

    }

}

function closeModal() {
    const modal = document.getElementById('morkes-quick-shop');

    if (!modal) return;

    modal.hidden = true;
    document.body.style.overflow = '';
}

function initializeProductForm(container) {

    const productDataEl = container.querySelector('.morkes-product-data');
    const form = container.querySelector('[data-morkes-product-form]');

    if (!productDataEl || !form) return;

    const product = JSON.parse(productDataEl.textContent);

    form.morkes = {
        product,
        currentVariant: product.selected_or_first_available_variant
    };

    const selects = form.querySelectorAll('.morkes-product-form__select');
    const variantInput = form.querySelector('[data-variant-id]');

    const buttonGroups = form.querySelectorAll('[data-option-buttons]');

    function updateVariant() {

        const selectedOptions = [...selects].map(select => select.value);

        const variant = product.variants.find(v =>
            v.options.every((option, index) => option === selectedOptions[index])
        );

        if (!variant) {
            console.warn('No matching variant found.');
            return;
        }

        form.morkes.currentVariant = variant;

        variantInput.value = variant.id;

        updateProductPrice(container, variant);

        updateOptionAvailability();

    }

    function updateOptionAvailability() {

        const selectedOptions = [...selects].map(select => select.value);

        buttonGroups.forEach((group, optionIndex) => {

            const buttons = group.querySelectorAll('.morkes-product-form__option-button');

            buttons.forEach(button => {

                const testOptions = [...selectedOptions];

                testOptions[optionIndex] = button.dataset.optionValue;

                const variantExists = product.variants.some(variant => {

                    if (!variant.available) return false;

                    return variant.options.every((option, index) =>
                        option === testOptions[index]
                    );

                });

                button.classList.toggle('is-disabled', !variantExists);

            });

        });

    }

    selects.forEach((select, index) => {

        select.addEventListener('change', () => {

            const buttons =
                buttonGroups[index]
                    ?.querySelectorAll('.morkes-product-form__option-button');

            buttons?.forEach(button => {

                button.classList.toggle(
                    'is-active',
                    button.dataset.optionValue === select.value
                );

            });

            updateVariant();

        });

    });

    buttonGroups.forEach((group, index) => {

        const buttons = group.querySelectorAll('.morkes-product-form__option-button');

        buttons.forEach(button => {

            button.addEventListener('click', () => {

                buttons.forEach(btn =>
                    btn.classList.remove('is-active')
                );

                button.classList.add('is-active');

                const select = selects[index];

                select.value = button.dataset.optionValue;

                select.dispatchEvent(
                    new Event('change', {
                        bubbles: true
                    })
                );

            });

        });

    });

    updateVariant();

}

function formatMoney(cents) {

    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    }).format(cents / 100);

}

function updateProductPrice(container, variant) {

    const quantityInput =
        container.querySelector('.morkes-product-form__quantity-input');

    const quantity = Number(quantityInput?.value || 1);

    const total = variant.price * quantity;

    const price = container.querySelector('[data-product-price]');
    const comparePrice = container.querySelector('[data-product-compare-price]');

    if (price) {
        price.textContent = formatMoney(total);
    }

    if (comparePrice) {

        if (variant.compare_at_price > variant.price) {

            comparePrice.textContent =
                formatMoney(variant.compare_at_price * quantity);

            comparePrice.style.display = '';

        } else {

            comparePrice.style.display = 'none';

        }

    }

}

function initializeQuantityControls(form) {

    if (!form) return;

    const container =
        form.closest('.morkes-product') ||
        form.closest('#morkes-quick-shop-content');

    const quantityInput = form.querySelector('.morkes-product-form__quantity-input');

    const minusButton = form.querySelector('[data-quantity-minus]');

    const plusButton = form.querySelector('[data-quantity-plus]');

    quantityInput?.addEventListener('input', () => {

        if (Number(quantityInput.value) < 1) {
            quantityInput.value = 1;
        }

        updateProductPrice(
            container,
            form.morkes.currentVariant
        );

    });

    minusButton?.addEventListener('click', () => {

        quantityInput.stepDown();

        if (quantityInput.value < 1) {
            quantityInput.value = 1;
        }

        updateProductPrice(
            container,
            form.morkes.currentVariant
        );

    });

    plusButton?.addEventListener('click', () => {

        quantityInput.stepUp();

        updateProductPrice(
            container,
            form.morkes.currentVariant
        );

    });

    form.addEventListener('submit', async (event) => {

        event.preventDefault();

        const submitButton = form.querySelector('button[type="submit"]');

        const message = form.querySelector('.morkes-product-form__message');

        submitButton.disabled = true;

        submitButton.textContent = 'Adding...';

        try {

            const formData = new FormData(form);

            const response = await fetch('/cart/add.js', {

                method: 'POST',

                body: formData

            });

            if (!response.ok) {

                throw new Error('Unable to add to cart.');

            }

            const product = await response.json();

            message.innerHTML = `
                ✓ <strong>${product.product_title}</strong> added to your cart.
                <a href="/cart">View Cart</a>
            `;

            message.classList.add('is-visible');

            submitButton.textContent = 'Added ✓';

        }

        catch (error) {

            message.textContent = 'Unable to add product to cart.';

            message.classList.add('is-visible');

            submitButton.textContent = 'Add to Cart';

        }

        submitButton.disabled = false;

    });

}

function initializeCarousel(carousel) {

    console.log('Initializing carousel', carousel);

    const track = carousel.querySelector('[data-carousel-track]');
    const slides = [...track.children];

    const prevButton = carousel.querySelector('[data-carousel-prev]');
    const nextButton = carousel.querySelector('[data-carousel-next]');

    const dotsContainer =
        carousel.querySelector('[data-carousel-dots]');

    if (!track || slides.length === 0) return;

    let currentIndex = 0;

    let startX = 0;

    let endX = 0;

    track.addEventListener('touchstart', (event) => {

        startX = event.touches[0].clientX;

    });

    track.addEventListener('touchend', (event) => {

        endX = event.changedTouches[0].clientX;

        const difference = startX - endX;

        if (Math.abs(difference) < 40) return;

        const maxIndex = Math.max(
            0,
            slides.length - getSlidesPerView()
        );

        if (difference > 0 && currentIndex < maxIndex) {

            currentIndex++;

        }

        if (difference < 0 && currentIndex > 0) {

            currentIndex--;

        }

        update();

    });

    function buildDots() {

        if (!dotsContainer) return;

        dotsContainer.innerHTML = '';

        slides.forEach((slide, index) => {

            const dot = document.createElement('button');

            dot.type = 'button';

            dot.className = 'morkes-carousel__dot';

            dot.addEventListener('click', () => {

                currentIndex = index;

                update();

            });

            dotsContainer.append(dot);

        });

    }

    function getSlidesPerView() {

        return Math.round(track.offsetWidth / slides[0].offsetWidth);

    }

    function update() {

        const slideWidth = slides[0].offsetWidth;
        const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0);

        track.style.transform =
            `translateX(-${currentIndex * (slideWidth + gap)}px)`;

        const maxIndex = Math.max(0, slides.length - getSlidesPerView());

        dotsContainer
            ?.querySelectorAll('.morkes-carousel__dot')
            .forEach((dot, index) => {

                dot.classList.toggle(
                    'is-active',
                    index === currentIndex
                );

            });

        prevButton.disabled = currentIndex === 0;
        nextButton.disabled = currentIndex >= maxIndex;

    }

    nextButton.addEventListener('click', () => {

        const maxIndex = Math.max(0, slides.length - getSlidesPerView());

        if (currentIndex < maxIndex) {
            currentIndex++;
            update();
        }

    });

    prevButton.addEventListener('click', () => {

        if (currentIndex > 0) {
            currentIndex--;
            update();
        }

    });

    window.addEventListener('resize', () => {

        const maxIndex = Math.max(0, slides.length - getSlidesPerView());

        if (currentIndex > maxIndex) {
            currentIndex = maxIndex;
        }

        update();

    });

    buildDots();

    update();

}

document.addEventListener('DOMContentLoaded', () => {

    function initializeStickyAddToCart() {

        const stickyBar =
            document.querySelector('[data-sticky-atc]');

        const stickyButton =
            document.querySelector('[data-sticky-atc-button]');

        const stickyPrice =
            document.querySelector('[data-sticky-price]');

        const productSection =
            document.querySelector('.morkes-product');

        if (!stickyBar || !stickyButton || !productSection) return;

        const productForm =
            productSection.querySelector('[data-morkes-product-form]');

        if (!productForm) return;

        const normalAddToCartButton =
            productForm.querySelector('button[type="submit"]');

        if (!normalAddToCartButton) return;


        /*
         * Show/hide sticky bar based on whether
         * the normal Add to Cart button is visible.
         */

        const observer = new IntersectionObserver(
            ([entry]) => {

                stickyBar.classList.toggle(
                    'is-visible',
                    !entry.isIntersecting
                );

            },
            {
                threshold: 0
            }
        );

        observer.observe(normalAddToCartButton);


        /*
         * Keep sticky price synchronized with
         * the currently selected variant.
         */

        function updateStickyPrice() {

            const variant =
                productForm.morkes?.currentVariant;

            if (!variant || !stickyPrice) return;

            const quantityInput =
                productForm.querySelector(
                    '.morkes-product-form__quantity-input'
                );

            const quantity =
                Number(quantityInput?.value || 1);

            const total =
                variant.price * quantity;

            stickyPrice.textContent =
                formatMoney(total);
        }

        /*
         * Watch for changes to variant selection
         * and quantity.
         */

        productForm.addEventListener('change', updateStickyPrice);

        productForm.addEventListener('input', updateStickyPrice);

        productForm.addEventListener('click', (event) => {

            if (
                event.target.closest('[data-quantity-minus]') ||
                event.target.closest('[data-quantity-plus]')
            ) {
                // Wait until the quantity control has updated the input.
                requestAnimationFrame(updateStickyPrice);
            }

        });

        updateStickyPrice();


        /*
         * Use the existing product form when
         * the sticky button is clicked.
         */

        stickyButton.addEventListener('click', () => {

            if (productForm.morkes?.currentVariant) {

                productForm.requestSubmit();

            }

        });

    }

    const productSection = document.querySelector('.morkes-product');

    if (productSection) {

        initializeProductForm(productSection);

        initializeQuantityControls(
            productSection.querySelector('.morkes-product-form')
        );

    }

    document.querySelectorAll('.morkes-carousel').forEach(initializeCarousel);

    initializeStickyAddToCart();

});

document.addEventListener('click', function (event) {

    const thumb = event.target.closest('[data-gallery-thumb]');

    if (!thumb) return;

    const gallery = thumb.closest('.morkes-product-gallery');

    if (!gallery) return;

    const image = gallery.querySelector('#morkes-product-gallery-image');

    if (!image) return;

    const newImageUrl = thumb.dataset.image;

    if (!newImageUrl) return;

    // Update active thumbnail
    gallery
        .querySelectorAll('[data-gallery-thumb]')
        .forEach(button => {
            button.classList.remove('is-active');
        });

    thumb.classList.add('is-active');

    // Change main image
    image.src = newImageUrl;

    // Keep responsive image attributes in sync
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');

    // Update alt text from the thumbnail image
    const thumbnailImage = thumb.querySelector('img');

    if (thumbnailImage?.alt) {
        image.alt = thumbnailImage.alt;
    }

});

document.addEventListener('click', function (event) {

    const button = event.target.closest('[data-tab-button]');

    if (!button) return;

    const tabs = button.closest('.morkes-product-tabs');

    const tab = button.dataset.tabButton;

    tabs.querySelectorAll('[data-tab-button]').forEach(btn => {
        btn.classList.remove('is-active');
    });

    tabs.querySelectorAll('[data-tab-panel]').forEach(panel => {
        panel.classList.remove('is-active');
    });

    button.classList.add('is-active');

    tabs
        .querySelector(`[data-tab-panel="${tab}"]`)
        .classList.add('is-active');

});

